import React, { useRef, useEffect } from 'react';

const ClipMask: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const img2Ref = useRef<HTMLImageElement>(null);
  const isUpdatingRef = useRef(false);
  const boxValuesRef = useRef({ x: 0, y: 0, w: 0, h: 0 });

  const updateBoxValues = () => {
    if (!containerRef.current) return;
    const box = containerRef.current;
    const rect = box.getBoundingClientRect();
    boxValuesRef.current = {
      x: rect.left,
      y: rect.top,
      w: rect.width,
      h: rect.height,
    };
  };

  const updateClipPath = (mouseX: number, mouseY: number) => {
    if (!img2Ref.current) return;

    const { x: boxX, y: boxY, w: boxW, h: boxH } = boxValuesRef.current;
    const xPercent = ((mouseX - boxX) / boxW) * 200;
    const yPercent = ((mouseY - boxY) / boxH) * 200;

    img2Ref.current.style.clipPath = `
      polygon(
        0% 0px,
        100% 0%,
        ${xPercent.toFixed(2)}% 0%,
        0% ${yPercent.toFixed(2)}%,
        0% 100%
      )
    `;

    isUpdatingRef.current = false;
  };

  const handleMouseMove = (e: MouseEvent) => {
    updateBoxValues();
    const mouseX = e.clientX;
    const mouseY = e.clientY;

    if (!isUpdatingRef.current) {
      isUpdatingRef.current = true;
      requestAnimationFrame(() => updateClipPath(mouseX, mouseY));
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    updateBoxValues();
    container.addEventListener('mousemove', handleMouseMove);

    const handleResize = () => {
      updateBoxValues();
    };
    window.addEventListener('resize', handleResize);

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const containerStyle: React.CSSProperties = {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: '8px',
  };

  const img1Style: React.CSSProperties = {
    height: '100%',
    width: 'auto',
    maxWidth: '100%',
    position: 'absolute',
    zIndex: 1,
    objectFit: 'contain',
  };

  const img2Style: React.CSSProperties = {
    height: '100%',
    width: 'auto',
    maxWidth: '100%',
    position: 'absolute',
    zIndex: 2,
    clipPath: 'polygon(0% 0px, 0% 0%, 0% 0%, 0% 0%, 0% 100%)',
    objectFit: 'contain',
  };

  return (
    <div className="clip-mask-container" ref={containerRef} style={containerStyle}>
      <img
        className="img2"
        ref={img2Ref}
        style={img2Style}
        src="https://xterminal.cn/_nuxt/1767254277616/app_blacked2DCjThr-q.png"
        alt="裁剪效果层"
      />
      <img
        className="img1"
        style={img1Style}
        src="https://xterminal.cn/app_white2.png"
        alt="基础层"
      />
    </div>
  );
};

export default ClipMask;